export function isMobile() {
  return /Android|iPhone|iPad|iPod|webOS/i.test(navigator.userAgent) || window.innerWidth < 768;
}

// Matches the CSS mobile breakpoint (styles.css @media max-width: 800px).
// Use this for logic tied to the mobile *layout* (bottom sheet, hidden
// attribution) so JS and CSS always agree; isMobile() is UA-based and can
// disagree with the layout (e.g. tablets at desktop widths).
export function isMobileLayout() {
  return window.matchMedia('(max-width: 800px)').matches;
}
